import DocumentsList from '../../components/docs/DocumentsList.jsx';

export default function DocumentsAdminPage() {
  return <DocumentsList target="all" title="All documents" isAdmin />;
}
